import { gql } from "@apollo/client";

const GET_PUBLIC_USER = gql`
  query PublicUser($token: String!) {
    publicUser(token: $token) {
      role
      name
      confirmed
      organizationName
      isPrimaryContact
      invitedByClientName
      expiredResetPasswordToken
    }
  }
`;

export { GET_PUBLIC_USER };
